export const BACK_URL = process.env.NODE_ENV === "development" ? "http://localhost:3333" : "https://node.new-wave.ecole-sainte-anne.com/"
